import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

//默认路由
export const defaultRouterMap = [{
	path: '/login',
	hidden: true,
	component: () => import('../views/login.vue')
}, {
	path: '/register',
	hidden: true,
	component: () => import('../views/register.vue')
},{
	path: '/noticeinfo/:id',
	hidden: true,
	component: () => import('../views/notice/noticeInfo/index.vue')
},{
	path: '/cgnoticeinfo/:id',
	hidden: true,
	component: () => import('../views/notice/cgNoticeInfo/index.vue')
},{
	path: '/tendernoticeinfo/:id',
	hidden: true,
	component: () => import('../views/notice/tenderNoticeInfo/index.vue')
},{
	path: '/morenotice/:type',
	hidden: true,
	component: () => import('../views/notice/moreNotice/index.vue')
},{
	path: '/auditinfo',
	hidden: true,
	component: () => import('../views/srm/AuditInfo/index.vue')
},{
	path: '/privacypolicy',	// 隐私协议
	hidden: true,
	component: () => import('../views/notice/privapo/index.vue')
},{
	path: '/gys/showauditinfo/:id',
	hidden: true,
	component: () => import('../views/gys/showAuditInfo/index.vue'),
	meta: {
		title: '审核详情'
	},
},{
		
	path: '/gys/gysInfoLast/:id',
	hidden: true,
	component: () => import('../views/gys/gysInfoLast/index.vue'),
	meta: {
		title: '供应商详情',
	}
},{
	path: '/404',
	hidden: true,
	component: () => import('../components/error/404.vue')
}, {
	path: '',
	component: () => import('../views/main'),
	redirect: 'welcome',
	children: [{
		path: 'welcome',
		name: '首页',
		meta: {
			icon: 'el-icon-s-home',
			title: '首页'
		},
		component: () => import('../components/Welcome'),
	}, {
		path: '/redirect',
		component: () => import('../views/redirect'),
		hidden: true
	},{
		path: '/gys/newgysinfo/:id',
		hidden: true,
		component: () => import('../views/gys/showAuditInfo/index.vue'),
		meta: {
			title: '供应商详情',
			icon: 'el-icon-coin'
		}
	},{
		path: 'omgOrderDetail/:id',
		component: () => import('../views/omg/OrderDetail/index'),
		name: 'omgOrderDetail',
		hidden: true,
		meta: {
			title: '订单明细',
			icon: 'el-icon-coin'
		}
	},{
		path: 'planinfo/:id',
		component: () => import('../views/transport/planInfo/index'),
		name: 'planinfo',
		hidden: true,
		meta: {
			title: '送货单明细',
			icon: 'el-icon-coin'
		}
	},{
		path: 'storeInfo/:id',
		component: () => import('../views/store/storeInfo/index'),
		name: 'storeInfo',
		hidden: true,
		meta: {
			title: '入库单明细',
			icon: 'el-icon-coin'
		}
	},{
		path: 'semtinfo/:id',
		component: () => import('../views/semt/semtInfo/index'),
		name: 'semtinfo',
		hidden: true,
		meta: {
			title: '发票明细',
			icon: 'el-icon-coin'
		}
	}]
},{
	path: '/srmXjOrderDetail',
	component: () => import('../views/main'),
	hidden: true,
	children: [{
		path: 'srmXjOrderDetail',
		component: () => import('../views/srm/srmXjOrderDetail/index'),
		name: 'SrmXjOrderDetail',
		meta: {
			title: '采购单明细',
			icon: 'el-icon-coin'
		}
	}]
},{
	path: '/gys/showgysinfo/:id',
	hidden: true,
	component: () => import('../views/gys/showAuditInfo/index.vue'),
	meta: {
		title: '供应商详情'
	},
},{
	path: '/srmXjOrderBj',
	component: () => import('../views/main'),
	hidden: true,
	children: [{
		path: 'srmXjOrderBj',
		component: () => import('../views/srm/srmXjOrderBj/index'),
		name: 'SrmXjOrderBj',
		meta: {
			title: '供应商报价',
			icon: 'el-icon-coin'
		}
	}]
},{
	path: '/orderAuditInfo',
	hidden: true,
	component: () => import('../views/srm/srmXjOrderDetail/index'),
	meta: {
		title: '审核详情',
		icon: 'el-icon-coin'
	}
},{
	path: '/user',
	component: () => import('../views/main'),
	hidden: true,
	children: [{
		path: 'profile',
		component: () => import('@/views/system/user/profile/index'),
		name: 'Profile',
		meta: {
			title: '个人中心',
			icon: 'el-icon-user'
		}
	}]
}, {
	path: '/gysRegister',
	component: () => import('../views/main'),
	hidden: true,
	children: [{
		path: 'gysRegister/:editId?',
		component: () => import('@/views/gys/gysRegister/index'),
		name: 'GysRegister',
		meta: {
			title: '企业注册',
			icon: 'el-icon-user'
		}
	}]
},{
	path: '/zbggNoticeInfo/:id',
	component: () => import('../views/zbggNoticeInfo.vue'),
	name: 'zbggNoticeInfo',
},{
	path: '/cgggNoticeInfo/:id',
	component: () => import('../views/cgggNoticeInfo.vue'),
	name: 'cgggNoticeInfo',
}
];
/** 
 * 动态路由
 */
/* const dynamicRouterMap = [{
	path: '/user',
	name: '用户列表',
	component: () => import('@/views/system/user/index'),
}, {
	path: '/role',
	name: '角色列表',
	component: () => import('@/views/system/role/index'),
}] */
const router = new VueRouter({
	mode: 'history', // hash  去掉url中的# 
	scrollBehavior: () => ({
		y: 0
	}), //每次跳转路由滚动到顶部
	routes: defaultRouterMap //赋值默认路由
})


export default router
